import * as inspector from "inspector-legacy/legacy/legacy";
export { inspector };
export default inspector;
